import { useQuery } from "@tanstack/react-query";
import type { UseQueryResult } from "@tanstack/react-query";

import { getPrivateInstance } from "../_privateInstance";
import { parseStaffRegulator } from "./parseStaffRegulator";
import { staffRegulatorByIdPath } from "./staffRegulatorPaths";
import type { StaffRegulator, StaffRegulatorEnvelope } from "./types";

export const fetchStaffRegulator = async (
  adminId: string,
): Promise<StaffRegulator> => {
  const response = await getPrivateInstance().get<
    StaffRegulatorEnvelope<unknown>
  >(staffRegulatorByIdPath(adminId));
  const parsed = parseStaffRegulator(response.data?.data);
  if (!parsed) {
    throw new Error("staff-regulators.invalid-detail");
  }
  return parsed;
};

export const useStaffRegulator = (
  adminId: string | undefined,
): UseQueryResult<StaffRegulator, Error> =>
  useQuery<StaffRegulator, Error>({
    queryKey: ["staff-regulators", "detail", adminId ?? ""],
    queryFn: () => fetchStaffRegulator(adminId as string),
    enabled: !!adminId,
    retry: false,
    staleTime: 1000 * 30,
    refetchOnWindowFocus: false,
  });
